export const CLOTHING_SIZE_FIELDS = [
  ["sizeSmall", "XS"],
  ["sizeMedium", "S"],
  ["sizeLarge", "M"],
  ["sizeSmallextraLarge", "L"],
  ["sizeXXLarge", "XL"],
  ["sizeXXXLarge", "XXL"],
];

export const FOOTWEAR_SIZE_FIELDS = [
  ["sizeSmall", "38"],
  ["sizeMedium", "39"],
  ["sizeLarge", "40"],
  ["sizeSmallextraLarge", "41"],
  ["sizeXXLarge", "42"],
  ["sizeXXXLarge", "43"],
];

/** @deprecated use CLOTHING_SIZE_FIELDS or getSizeFieldsForProfile */
export const PRODUCT_SIZE_FIELDS = CLOTHING_SIZE_FIELDS;

export const getSizeFieldsForProfile = (sizeMode) => {
  if (sizeMode === "footwear") return FOOTWEAR_SIZE_FIELDS;
  return CLOTHING_SIZE_FIELDS;
};

export const parseSizeStock = (value) => {
  const parsed = parseInt(String(value ?? "").trim(), 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const sumSizeStock = (productOrForm, sizeFields = CLOTHING_SIZE_FIELDS) =>
  sizeFields.reduce((total, [field]) => total + parseSizeStock(productOrForm?.[field]), 0);

export const getProductSizes = (product, sizeFields = CLOTHING_SIZE_FIELDS) => {
  if (!product) return [];
  return sizeFields
    .map(([field, label]) => ({
      field,
      label,
      stock: parseSizeStock(product[field]),
    }))
    .filter((entry) => entry.stock > 0)
    .map(({ field, label, stock }) => ({
      field,
      label,
      value: label,
      stock,
    }));
};

export const getSizeStock = (product, selectedSize, sizeFields = CLOTHING_SIZE_FIELDS) => {
  if (!product || !selectedSize) return 0;
  const match = sizeFields.find(([, label]) => label === selectedSize);
  if (!match) return 0;
  return parseSizeStock(product[match[0]]);
};

export const getProductStockAvailable = (product, selectedSize = null, sizeFields = CLOTHING_SIZE_FIELDS) => {
  if (!product) return 0;
  if (selectedSize) return getSizeStock(product, selectedSize, sizeFields);

  const sizeTotal = sumSizeStock(product, sizeFields);
  if (sizeTotal > 0) return sizeTotal;

  return Math.max(0, parseInt(product.quantity, 10) || 0);
};

export const cartLineKey = (item) => `${item._id}::${item.selectedSize || ""}`;
